import api from "./api";
import type { UserRoles } from "@/types/auth";

/** One user of the organization and their AI access (backend ``AgentAccessUserSerializer``). */
export interface AgentAccessUser {
  id: number;
  email: string;
  company_name: string;
  role: UserRoles;
  agent_access: boolean;
  agent_access_changed_at: string | null;
  /** Who last changed it: an email in the organization, "Steddy" for staff; null for the system. */
  agent_access_changed_by: string | null;
}

export interface AgentAccessList {
  organization: { id: number; name: string };
  users: AgentAccessUser[];
}

export interface UpdateAgentAccessRequest {
  user_ids: number[];
  agent_access: boolean;
}

/** Which of the organization's users may use the AI assistant; its admins only. */
export const agentAccessService = {
  list: async (): Promise<AgentAccessList> => {
    const { data } = await api.get<AgentAccessList>(
      `/accounts/organization-settings/agent-access/`
    );
    return data;
  },

  /** One user or many at once; returns the list after the change. */
  update: async (payload: UpdateAgentAccessRequest): Promise<AgentAccessList> => {
    const { data } = await api.patch<AgentAccessList>(
      `/accounts/organization-settings/agent-access/`,
      payload
    );
    return data;
  },
};
